import { Badge } from "react-bootstrap";

function MessageProgressIcon({
    type
}) {
    let sizeClass = "sm";

    switch (type) {
        case 'request_revision':
            return <Badge bg="orange" className={`badge-outline ${sizeClass}`} pill>Revision</Badge>;
        case 'submit_for_approval':
            return <Badge bg="success" className={`badge-outline ${sizeClass}`} pill>Sent</Badge>;
        case 'void_submission':
            return <Badge bg="orange" className={`badge-outline ${sizeClass}`} pill>Cancelled</Badge>;
        case 'approve':
            return <Badge bg="success" className={`badge-outline ${sizeClass}`} pill>Approved</Badge>;
        case 'accept_request':
            return <Badge bg="success" className={`badge-outline ${sizeClass}`} pill>Accepted</Badge>;
        case 'reject_request':
            return <Badge bg="orange" className={`badge-outline ${sizeClass}`} pill>Rejected</Badge>;
        default:
            return null;
    }
}

export { MessageProgressIcon }